import { useCallback, useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import api from '../../../utils/api';
import { EnterpriseEndpoints } from '../../../utils/endpoints';
import { apiErrorMessage } from '../../../utils/apiError';
import { formatInstantLagos } from '../../../utils/datetime';
import PageHeader from '../../shell/PageHeader';
import { Alert, Button, Card, DetailRow } from '../../ui';
import EnterpriseDeactivated, { isEnterpriseDeactivated } from './enterprise/EnterpriseDeactivated';

const breadcrumbs = [{ label: 'Home', to: '/layout' }, { label: 'Bank Account' }];

const EnterpriseBankAccount = () => {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setLoadError(null);
    api
      .get(EnterpriseEndpoints.bankAccount)
      .then((response) => setAccount(response?.data?.data ?? null))
      .catch(setLoadError)
      .finally(() => setLoading(false));
  }, []);

  useEffect(load, [load]);

  if (isEnterpriseDeactivated(loadError)) {
    return (
      <>
        <PageHeader title="Bank Account" breadcrumbs={breadcrumbs} />
        <EnterpriseDeactivated />
      </>
    );
  }

  return (
    <>
      <PageHeader title="Bank Account" breadcrumbs={breadcrumbs} />

      {loadError ? (
        <Alert variant="danger" className="mb-6">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <span>{apiErrorMessage(loadError, 'We could not load your bank account. Please try again.')}</span>
            <Button variant="outline-danger" size="sm" onClick={load}>
              <RefreshCw className="w-4 h-4" aria-hidden="true" />
              Retry
            </Button>
          </div>
        </Alert>
      ) : (
        <Card title="Settlement account">
          <DetailRow label="Bank" loading={loading} value={account?.bank_name ?? account?.bank_code} />
          <DetailRow label="Account name" loading={loading} value={account?.account_name} />
          <DetailRow label="Account number" loading={loading} value={account?.account_number} />
          <DetailRow label="Verified (WAT)" loading={loading} value={formatInstantLagos(account?.verified_at)} />
          <p className="mt-4 text-sm text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
            Every payout goes to this account. To change it, contact CashAfrica support.
          </p>
        </Card>
      )}
    </>
  );
};

export default EnterpriseBankAccount;
